import { api } from "@/lib/axios";

interface companyCreationProps {
  companyName: string;
  companyEmail: string;
  companyAddress: string;
  companyState: string;
  companyZip: string;
  companyCity: string;
}

export async function createCompany({
  companyName,
  companyEmail,
  companyAddress,
  companyState,
  companyZip,
  companyCity,
}: companyCreationProps) {
  return await api.post("/company", {
    companyName,
    companyEmail,
    companyAddress,
    companyState,
    companyZip,
    companyCity,
  });
}
